module.exports = __webpack_public_path__ + "static/media/trn-talk.96f752a4.png";